<!-- Modal -->
<div
  class="modal fade"
  id="nuevoUsuarioModal"
  tabindex="-1"
  aria-labelledby="nuevoUsuarioModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="nuevoUsuarioModalLabel">
          {{ modoEditar ? "Editar Usuario" : "Nuevo Usuario" }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="modoEditar ? actualizarUsuario() : agregarUsuario()">
          <div class="row">
            <div class="col-md-4 mb-4">
              <label for="nombreCompleto" class="form-label"
                >Nombre y Apellido</label
              >
              <input
                type="text"
                class="form-control"
                id="nombreCompleto"
                [(ngModel)]="nuevoUsuario.nombreCompleto"
                name="nombreCompleto"
                required
              />
              <div *ngIf="errores['nombreCompleto']" class="text-danger">
                {{ errores["nombreCompleto"] }}
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <label for="usuario" class="form-label">Usuario</label>
              <input
                type="text"
                class="form-control"
                id="usuario"
                [(ngModel)]="nuevoUsuario.usuario"
                name="usuario"
                required
              />
              <div *ngIf="errores['usuario']" class="text-danger">
                {{ errores["usuario"] }}
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <label for="roles" class="form-label">Roles</label>
              <div>
                <div *ngFor="let rol of roles">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [id]="rol"
                    [checked]="rolesSeleccionados[rol]"
                    (change)="onRoleChange($event, rol)"
                  />
                  <label class="form-check-label ms-1" [for]="rol">{{
                    rol
                  }}</label>
                </div>
              </div>
              <div *ngIf="errores['roles']" class="text-danger">
                {{ errores["roles"] }}
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <label for="contrasena" class="form-label">Contraseña</label>
              <input
                type="password"
                class="form-control"
                id="contrasena"
                [(ngModel)]="nuevoUsuario.contrasena"
                name="contrasena"
                [required]="!modoEditar"
              />
              <div *ngIf="errores['contrasena']" class="text-danger">
                {{ errores["contrasena"] }}
              </div>
            </div>
            <div class="col-md-4 mb-4">
              <label for="contrasenaRepetida" class="form-label"
                >Repetir Contraseña</label
              >
              <input
                type="password"
                class="form-control"
                id="contrasenaRepetida"
                [(ngModel)]="nuevoUsuario.contrasenaRepetida"
                name="contrasenaRepetida"
                [required]="!modoEditar"
              />
              <div *ngIf="errores['contrasenaRepetida']" class="text-danger">
                {{ errores["contrasenaRepetida"] }}
              </div>
            </div>
            <div *ngIf="modoEditar" class="col-md-4 mb-4">
              <label for="activo" class="form-label">Activo</label>
              <input
                type="checkbox"
                class="form-check-input"
                id="activo"
                [(ngModel)]="nuevoUsuario.activo"
                name="activo"
              />
            </div>
          </div>
          <button type="submit" class="btn btn-primary" id="guardarEdicion">
            Guardar Usuario
          </button>
          <button
            id="eliminarUsuario"
            *ngIf="modoEditar"
            type="button"
            class="btn btn-danger ms-2"
            (click)="eliminarUsuario(nuevoUsuario.id)"
          >
            Eliminar Usuario
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
